import { TELEGRAM_BOT_LINK } from "src/constants/links";
import { RoutesPaths } from "src/routes/RoutesPaths";

export interface TermsPromotion {
  title: string;
  description: React.ReactNode;
  link?: string;
  blank?: boolean;
}

export const termsPromotion: TermsPromotion[] = [
  {
    title: "Привязать Telegram аккаунт",
    description:
      "Чтобы привязать аккаунт необходимо перейти в профиль или нажать на ссылку у данного пункта и в блоке персональной информаци авторизоваться через необходимую социальную сеть",
    link: RoutesPaths.LK.PROFILE.BASE_PATH,
  },
  {
    title: "Разрешить писать в Telegram",
    description:
      "Чтобы разрешить нашему боту писать вам в Telegram, необходимо перейти по ссылке у данного пункта и нажать СТАРТ в чате",
    link: TELEGRAM_BOT_LINK,
    blank: true,
  },
];
